import { render, staticRenderFns } from "./CreateBlockDrawer.vue?vue&type=template&id=7e0916dd&scoped=true&"
import script from "./CreateBlockDrawer.vue?vue&type=script&lang=js&"
export * from "./CreateBlockDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CreateBlockDrawer.vue?vue&type=style&index=0&id=7e0916dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0916dd",
  null
  
)

export default component.exports